import '../../../hooks/index.mjs';
import '../../../types/index.mjs';
import EN_TRANSLATION from './en.json.mjs';
import { useTranslation } from '../../../hooks/useTranslation.mjs';
import { Language } from '../../../types/constants.mjs';
"use strict";
const useModelCompareTranslation = () => useTranslation({
  defaultTranslation: EN_TRANSLATION,
  additionalTranslations: {
    [Language.Ar]: () => import('./ar.json.mjs').then(res => res.default),
    [Language.Ca]: () => import('./ca.json.mjs').then(res => res.default),
    [Language.Cs]: () => import('./cs.json.mjs').then(res => res.default),
    [Language.Da]: () => import('./da.json.mjs').then(res => res.default),
    [Language.Nl]: () => import('./nl.json.mjs').then(res => res.default),
    [Language.Fr]: () => import('./fr.json.mjs').then(res => res.default),
    [Language.De]: () => import('./de.json.mjs').then(res => res.default),
    [Language.El]: () => import('./el.json.mjs').then(res => res.default),
    [Language.It]: () => import('./it.json.mjs').then(res => res.default),
    [Language.Ja]: () => import('./ja.json.mjs').then(res => res.default),
    [Language.Ko]: () => import('./ko.json.mjs').then(res => res.default),
    [Language.No]: () => import('./no.json.mjs').then(res => res.default),
    [Language.Pl]: () => import('./pl.json.mjs').then(res => res.default),
    [Language.PtPt]: () => import('./pt-PT.json.mjs').then(res => res.default),
    [Language.EsMx]: () => import('./es-MX.json.mjs').then(res => res.default),
    [Language.Sv]: () => import('./sv.json.mjs').then(res => res.default),
    [Language.Tr]: () => import('./tr.json.mjs').then(res => res.default),
    [Language.Zh]: () => import('./zh-Hans.json.mjs').then(res => res.default),
    [Language.Tw]: () => import('./zh-Hant-TW.json.mjs').then(res => res.default),
    [Language.PtBr]: () => import('./pt-BR.json.mjs').then(res => res.default),
    [Language.Ru]: () => import('./ru.json.mjs').then(res => res.default),
    [Language.EsEs]: () => import('./es-ES.json.mjs').then(res => res.default)
  }
});
export { useModelCompareTranslation };
//# sourceMappingURL=useModelCompareTranslation.mjs.map
